import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NEW_PLANPAGE_URL } from 'constants/index';
import _get from 'lodash.get';
import Cookie from 'utils/cookies';
import Link from 'components/Link';
import { getGa4PageViewSet, collectEventfireGa4 } from 'utils/common';
import {
  newPlanpageMetaData,
  redirectToNewPlanpage,
  sendDataToGAWithGRX,
} from 'components/ToiSubscription/utils/redirectionToPlanPage';
import { getPrcCookieValue, getEncTicket } from 'utils/primeUtil';
import InViewObserver from 'components/InViewObserver/InViewObserver';

import s from './ToiPlusPlanPageCta.scss';

function ToiPlusPlanPageCta(props) {
  const {
    showToiPlusEntryPoints,
    unifiedNodes,
    userData,
    userPrcData,
    msid,
    pageType,
    AdSlotnum,
    adname,
  } = props;

  const fireGA4 = obj => {
    const gaPageViewObj = getGa4PageViewSet() || {};
    const collatedGadata = {
      ...gaPageViewObj,
      event: 'select_item',
    };
    return collectEventfireGa4(collatedGadata, {
      item_name:
        window.location.href.indexOf('.cms') > -1
          ? document.title
          : window.location.href,
      item_id: msid || '',
      item_brand: 'product_interventions',
      item_category: 'Nudges',
      item_category2: pageType,
      item_category3: obj?.item_category3 ? obj?.item_category3 : 'N/A',
      item_category4: obj?.item_category4 ? obj?.item_category4 : 'N/A',
      location_id: obj?.location_id ? obj?.location_id : 'N/A',
    });
  };

  const redirection = () => {
    const prc = getPrcCookieValue();
    const getUnifiedNodes = unifiedNodes[`prc${prc || 0}`];
    if (Cookie.get('ssoid') || Cookie.get('ssoId')) {
      getEncTicket(false).then(data => {
        window.location.href = redirectToNewPlanpage(
          newPlanpageMetaData(
            {
              unifiedNodes: getUnifiedNodes,
              acqSubSource: `ads_free_inline_mrec_nudge_${adname}`,
            },
            data,
          ),
        );
      });
    } else {
      window.location.href = redirectToNewPlanpage(
        newPlanpageMetaData({
          unifiedNodes: getUnifiedNodes,
          acqSubSource: `ads_free_inline_mrec_nudge_${adname}`,
        }),
      );
    }
  };
  const handleSubscribeNowCTA = e => {
    e.preventDefault();
    const grxParams = [
      'paywall',
      {
        client_source: 'cdp',
        event_nature: 'click',
        event_category: 'subscription',
        cta_text: e.target.innerText || '',
        unique_subscription_id: `${Cookie.get('_grx')}_${new Date().getTime()}`,
      },
    ];
    let cdpInfo = {};
    if (
      typeof window.grx !== 'undefined' &&
      typeof window?.grx_module?.hitPaywallEventReact === 'function'
    ) {
      window.grx_module.hitPaywallEventReact(...grxParams);
      cdpInfo = window.grx_module.getCdpInfo() || {};
    } else {
      window.Times.setGRXDataInLocalStorage('GRX_QUEUE_EVENT', {
        eventName: grxParams[0],
        payload: grxParams[1],
      });
    }
    const cdpParamsObj = grxParams[1] || {};
    const dataToBepassed = {
      source: userPrcData?.source,
      accessType: userPrcData?.accessType,
      analytics_cdp: {
        eventName: grxParams[0],
        ...cdpParamsObj,
        ...cdpInfo,
      },
      objUserData: {
        email:
          typeof userData?.getEmail !== 'undefined' ? userData.getEmail() : '',
        fname:
          typeof userData?.getFirstName !== 'undefined'
            ? userData.getFirstName()
            : '',
      },
      ga4Items: fireGA4({
        item_category4: e.target.innerText || '',
        item_category3: `ads_free_inline_mrec_nudge_${adname}`,
      }),
    };
    sendDataToGAWithGRX(dataToBepassed)
      .then(redirection)
      .catch(redirection);
  };

  return (
    <div className={s.toiplusButtonWrapper}>
      <InViewObserver>
        <div className={s.ad_free_wrapper}>
          <span className={s.link_text}>Tired of too many ads?</span>
          <Link
            type="button"
            className={s.cta}
            to={NEW_PLANPAGE_URL}
            onClick={e => {
              handleSubscribeNowCTA(e);
            }}
          >
            go ad free now
          </Link>
        </div>
      </InViewObserver>
    </div>
  );
}

ToiPlusPlanPageCta.propTypes = {
  showToiPlusEntryPoints: PropTypes.bool,
  unifiedNodes: PropTypes.shape({}),
  userData: PropTypes.bool,
  userPrcData: PropTypes.string,
  msid: PropTypes.string,
  pageType: PropTypes.string,
  AdSlotnum: PropTypes.string,
  adname: PropTypes.string,
};
ToiPlusPlanPageCta.defaultProps = {
  showToiPlusEntryPoints: '',
  unifiedNodes: {},
  userData: '',
  userPrcData: '',
  msid: '',
  pageType: '',
  AdSlotnum: '',
  adname: '',
};

const mapStateToProps = state => ({
  userPrcData: state.login.userPrcData,
  unifiedNodes: _get(state, 'translationConfig.nudges.unifiedNodes', {}),
  userData: state.login.userData,
  showToiPlusEntryPoints: _get(
    state,
    'toiplusconfig.showToiPlusEntryPoints',
    false,
  ),
});

export default connect(mapStateToProps, null)(ToiPlusPlanPageCta);
